import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import { Login } from "@/pages/admin/Login";
import { EventsManager } from "@/pages/admin/EventsManager";
import { ContentManager } from "@/pages/admin/ContentManager";
import { NewsletterAdmin } from "@/pages/admin/Newsletter";
import { Settings } from "@/pages/admin/Settings";
import { AnalyticsDashboard } from "@/pages/admin/AnalyticsDashboard";
import { BookingManager } from "@/pages/admin/BookingManager";
import { AdminLayout } from "@/layouts/AdminLayout";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { TicketShop } from "@/pages/TicketShop";
import { TicketSuccess, TicketCancel } from "@/pages/TicketResult";
import CheckInScanner from "@/pages/admin/CheckInScanner";
import PublicBooking from "@/pages/PublicBooking";
import RoomBookingPage from "@/pages/RoomBookingPage";
import UserLogin from "@/pages/UserLogin";
import { PasswordResetRequest, PasswordResetConfirm } from "@/pages/PasswordReset";
import { BookingSuccess, BookingCancel } from "@/pages/BookingResult";
import CancelBooking from "@/pages/CancelBooking";
import NewsletterConfirm from "@/pages/NewsletterConfirm";
import { UserProfilePage } from "@/pages/UserProfilePage";
import UserConfirm from "@/pages/UserConfirm";
import CookieBanner from "@/components/CookieBanner";
import AnnyBookingPage from "@/pages/AnnyBookingPage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/cms" element={<Login />} />
            <Route path="/admin/login" element={<Login />} />
            
            {/* Ticket Shop */}
            <Route path="/tickets/:eventId" element={<TicketShop />} />
            <Route path="/tickets/success" element={<TicketSuccess />} />
            <Route path="/tickets/cancel" element={<TicketCancel />} />
            
            {/* Room Booking (Public) */}
            <Route path="/buchung" element={<PublicBooking />} />
            <Route path="/buchung/:roomId" element={<RoomBookingPage />} />
            
            {/* External Booking via anny.co */}
            <Route path="/raum-buchen/:roomSlug" element={<AnnyBookingPage />} />
            <Route path="/buchung/success" element={<BookingSuccess />} />
            <Route path="/buchung/cancel" element={<BookingCancel />} />
            <Route path="/buchung/stornieren" element={<CancelBooking />} />
            
            {/* User Login/Register */}
            <Route path="/login" element={<UserLogin />} />
            <Route path="/passwort-vergessen" element={<PasswordResetRequest />} />
            <Route path="/passwort-zuruecksetzen" element={<PasswordResetConfirm />} />
            
            {/* User Profile */}
            <Route path="/mein-bereich" element={<UserProfilePage />} />
            
            {/* User Email Confirmation */}
            <Route path="/konto/bestaetigen" element={<UserConfirm />} />
            
            {/* Newsletter Confirmation */}
            <Route path="/newsletter/confirm" element={<NewsletterConfirm />} />
            
            {/* QR Check-in Scanner (standalone for mobile) */}
            <Route path="/admin/checkin/:eventId" element={<CheckInScanner />} />
            
            <Route path="/admin" element={<AdminLayout />}>
               <Route index element={<ContentManager />} />
               <Route path="content" element={<ContentManager />} />
               <Route path="events" element={<EventsManager />} />
               <Route path="booking" element={<BookingManager />} />
               <Route path="newsletter" element={<NewsletterAdmin />} />
               <Route path="analytics" element={<AnalyticsDashboard />} />
               <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
